/* eslint-disable  */
import { ArrowBackIos } from "@material-ui/icons";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import { io } from "socket.io-client";
import {
  authActionCreators,
  messagesActionCreators,
} from "../../../service/action-creators";
import axiosInstance from "../../../service/axios/axios";
import Loader from "../../Loader";
import Modal from "../../Modal/Modal";
import RenderHome from "../home/RenderHome";
import Conversation from "./Conversation";
import Message from "./Message";
import "./Messenger.css";

function Messenger() {
  const dispatch = useDispatch();
  const scrollRef = useRef();
  const auth = useSelector((state) => state.auth);
  const chat = useSelector((state) => state.messages);
  const [openChatModal, setChatOpenModal] = useState(false);

  const { usersForChat, response } = chat;
  const isLoading = chat?.isLoading;

  const {
    GetConversations,
    GetUsersForChat,
    CreateConversation,
    ResetMessagesResponse,
  } = bindActionCreators(messagesActionCreators, dispatch);
  const { GetUserProfile } = bindActionCreators(authActionCreators, dispatch);

  const [message, setMessage] = useState("");
  const [currentChat, setCurrentChat] = useState(null);
  const [chats, setChats] = useState([]);
  const [arrivalMessage, setArrivalMessage] = useState(null);
  const [showMobile, setShowMobile] = useState(false);
  const [changeConversationUser, setChangeConversationUser] = useState("0");
  const [conversationTitle, setConvertionTitle] = useState("");

  const disp = showMobile ? "block" : "none";
  const hide = showMobile ? "none" : "block";
  const socket = useRef();
  const prevChatIdRef = useRef(null);

  const device = () => window.innerWidth < 1080;
  const [isMobile, setIsMobile] = useState(device);

  useEffect(() => {
    window.addEventListener("resize", () => setIsMobile(device));
    return 0;
  }, []);

  // Initialize socket with correct events for new NestJS gateway
  useEffect(() => {
    // socket.current = io("http://localhost:8900");
    socket.current = io("https://api.upnmg.com");

    socket.current.on("message:new", (data) => {
      setArrivalMessage(data);
    });

    GetUserProfile();
    GetConversations(auth?.user?._id);
    GetUsersForChat();

    return () => {
      socket.current.disconnect();
    };
  }, []);

  // Register user with socket when auth is available
  useEffect(() => {
    if (!auth?.user?._id || !socket.current) return;
    socket.current.emit("user:register", { userId: auth?.user?._id });
  }, [auth?.user?._id]);

  // Join/leave conversation room when currentChat changes
  useEffect(() => {
    if (!socket.current) return;
    if (prevChatIdRef.current) {
      socket.current.emit("conversation:leave", {
        conversationId: prevChatIdRef.current,
      });
    }
    if (currentChat?._id) {
      socket.current.emit("conversation:join", {
        conversationId: currentChat._id,
      });
      prevChatIdRef.current = currentChat._id;
    }
  }, [currentChat?._id]);

  // Append incoming messages from socket
  useEffect(() => {
    if (!arrivalMessage || !currentChat) return;
    if (currentChat.members) {
      // Old Conversation system — check sender is in this conversation
      if (currentChat.members.includes(arrivalMessage?.sender_id)) {
        setChats((prev) => [...prev, arrivalMessage]);
      }
    } else {
      // MembersMessages system — any message arriving in this room belongs here
      setChats((prev) => [...prev, arrivalMessage]);
    }
  }, [arrivalMessage]);

  // Load messages when a conversation is selected
  useEffect(() => {
    if (!currentChat) return;
    const getMessage = async () => {
      try {
        if (currentChat.reference !== undefined && !currentChat.members) {
          // MembersMessages: chat array is embedded in the document itself
          setChats(currentChat.chat || []);
          return;
        }
        // Old Conversation/Message system: fetch from separate Message collection
        const res = await axiosInstance.get(
          `/messenger/messages/${currentChat._id}`
        );
        setChats(res.data?.chat || []);
      } catch (error) {
        console.log("error", error);
      }
    };
    getMessage();
  }, [currentChat]);

  // Scroll to bottom when chats update
  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chats]);

  const handleChangeUserConversation = (e) => {
    setChangeConversationUser(e.target.value);
  };

  const handleCreateConversation = (e) => {
    e.preventDefault();
    if (changeConversationUser === "0") {
      toast.error("Please select user first");
      return;
    }
    if (conversationTitle === "") {
      toast.error("Please conversation title is required");
      return;
    }
    const payload = [auth?.user?._id, changeConversationUser];
    CreateConversation(payload, conversationTitle);
    setChatOpenModal(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;

    const isMembersMessages =
      !currentChat?.members && currentChat?.reference !== undefined;

    if (isMembersMessages) {
      // MembersMessages system — POST to /messages with reference
      try {
        const payload = {
          message,
          user_id: auth?.user?._id,
          reference: currentChat?.reference,
          system_user: currentChat?.system_user,
          member_profile: auth?.user?.profile_image,
        };
        await axiosInstance.post("/messages", payload);
        setMessage("");
        // Backend emits message:new to conversation room — socket will append it
      } catch (error) {
        console.log("error", error);
      }
    } else {
      // Old Conversation/Message system
      const data = {
        sender: auth?.user?._id,
        text: message,
        conversationId: currentChat?._id,
      };
      try {
        const res = await axiosInstance.post("/messenger/messages", data);
        if (res) {
          // Old system has no socket emit, so append locally
          setChats((prev) => [
            ...prev,
            {
              sender_id: auth?.user?._id,
              message,
              data: new Date(),
            },
          ]);
          setMessage("");
        }
      } catch (error) {
        console.log("error", error);
      }
    }
  };

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      setTimeout(() => {
        ResetMessagesResponse();
        GetConversations(auth?.user?._id);
      }, 1500);
    } else if (response?.state === "ERROR") {
      setTimeout(() => {
        ResetMessagesResponse();
      }, 1500);
    }
  }, [response?.state]);

  // Determine if a chat entry was sent by the current user
  const getOwn = (ch) => {
    if (ch.user_type) {
      return ch.user_type === "member";
    }
    return ch.sender_id === auth?.user?._id;
  };

  const renderChatBox = () => (
    <>
      {currentChat ? (
        <>
          <div className="chatBoxTop">
            {chats?.map((ch, i) => (
              <div ref={scrollRef} key={i}>
                <Message own={getOwn(ch)} mesgs={ch} auth={auth} />
              </div>
            ))}
          </div>
          <div className="chatBoxBottom">
            <textarea
              className="chatMessageInput"
              name="message"
              value={message}
              onChange={(e) => setMessage(e?.target?.value)}
              placeholder="Start writing your message here..."
            ></textarea>
            <button className="button" onClick={handleSubmit}>
              Send
            </button>
          </div>
        </>
      ) : (
        <div className="">
          <p className="openConversationText">
            Open new conversation for new chat
          </p>
          <div className="createChatArrea">
            <p>
              <button onClick={() => setChatOpenModal(true)}>create chat</button>
            </p>
          </div>
        </div>
      )}
    </>
  );

  return (
    <div className="">
      <RenderHome>
        {isLoading && <Loader />}
        <div className="messenger">
          {isMobile ? (
            <div className="chatConversation" style={{ display: hide }}>
              {chat?.conversations.map((conversation, index) => (
                <div
                  key={index}
                  onClick={() => {
                    setCurrentChat(conversation);
                    setArrivalMessage(null);
                    setShowMobile(true);
                  }}
                >
                  <Conversation conversation={conversation} />
                </div>
              ))}
            </div>
          ) : (
            <div className="chatConversation">
              {chat?.conversations.map((conversation, index) => (
                <div
                  key={index}
                  onClick={() => {
                    setCurrentChat(conversation);
                    setArrivalMessage(null);
                  }}
                >
                  <Conversation conversation={conversation} />
                </div>
              ))}
              <button
                className="custom_btn"
                onClick={() => setChatOpenModal(true)}
              >
                Create Chat
              </button>
            </div>
          )}

          {isMobile ? (
            <div className="chatBox" style={{ display: disp }}>
              <div className="chatBoxWrapper">
                <div
                  onClick={() => setShowMobile(false)}
                  className="backArrow"
                >
                  <ArrowBackIos style={{ fontSize: ".7rem" }} />
                  <span>Back</span>
                </div>
                {renderChatBox()}
              </div>
            </div>
          ) : (
            <div className="chatBox">
              <div className="chatBoxWrapper">{renderChatBox()}</div>
            </div>
          )}
        </div>

        {openChatModal && (
          <Modal width={"30%"} closeModal={setChatOpenModal}>
            <form>
              <div>
                <div className="mb-6">
                  <label
                    htmlFor="title"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    Chat Title
                  </label>
                  <input
                    type="title"
                    name="title"
                    id="title"
                    onChange={(e) => setConvertionTitle(e.target.value)}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="Enter the title of your conversation"
                    required
                  />
                </div>

                <label
                  htmlFor="countries"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400"
                >
                  Select Officer
                </label>
                <select
                  onChange={handleChangeUserConversation}
                  id="countries"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                >
                  <option value={"0"}>Choose user</option>
                  {usersForChat?.map((user, i) => (
                    <option key={i} value={user?._id}>
                      {`${user?.name.split(" ")[1]} (${user?.officer})`}
                    </option>
                  ))}
                </select>
              </div>
              <div className="modalButton">
                <div className="flex items-center p-6 space-x-2 rounded-b border-t border-gray-200 dark:border-gray-600">
                  <div className="">
                    <button
                      className="custom_btn"
                      onClick={handleCreateConversation}
                    >
                      create chat
                    </button>
                  </div>
                  <button
                    data-modal-toggle="defaultModal"
                    type="button"
                    onClick={() => setChatOpenModal(false)}
                    className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </Modal>
        )}
      </RenderHome>
    </div>
  );
}

export default Messenger;
